import { CallbackCache } from '../../common/CallbackCache';
import { TokenResult } from '../../services/common/token';
import { TokenRenewalResult } from './RenewableToken';

export default class RenewTokenCallbackCache extends CallbackCache<TokenResult, TokenRenewalResult> {}
